import { useEffect, useRef } from 'react';
import { useGetMeQuery, useRefreshTokenMutation } from '../store/api/authApi';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setUser, setAccessToken, clearUser, REFRESH_TOKEN_KEY } from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { accessToken } = useAppSelector((state) => state.auth);
  const [refreshToken] = useRefreshTokenMutation();
  const refreshAttempted = useRef(false);

  // On mount, restore session from refresh token in localStorage if no access token
  useEffect(() => {
    if (accessToken || refreshAttempted.current) return;
    refreshAttempted.current = true;

    const rt = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (rt) {
      refreshToken({ refreshToken: rt })
        .unwrap()
        .then(({ accessToken: at }) => {
          dispatch(setAccessToken(at));
        })
        .catch(() => {
          localStorage.removeItem(REFRESH_TOKEN_KEY);
        });
    }
  }, []);

  const { data, error, isLoading, isFetching } = useGetMeQuery(undefined, {
    skip: !accessToken,
  });

  useEffect(() => {
    if (data?.user) {
      dispatch(setUser(data.user));
    } else if (error) {
      dispatch(clearUser());
    }
  }, [data, error, dispatch]);

  return {
    user: data?.user ?? null,
    isAuthenticated: !!data?.user,
    isLoading: isLoading || isFetching,
  };
};
